import { useState } from "react";
import { URL_API } from "../../../config/default";
import { myHeaders } from "../../../config/axios";
import { CustomToast } from "../../../utils/custom-toast";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

const Comisiones = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({
    value: 0,
    province: "Córdoba",
    status: "activo",
    type: "mercadopago",
  });
  const { isPending, error, data } = useQuery({
    queryKey: ["commissions"],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      return fetch(`${URL_API}/commissions/1`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => res.json());
    },
  });

  if (isPending) return "Loading...";

  if (error) {
    navigate("/404");
    return null;
  }

  if (!data || !data.data) {
    navigate("/404");
    return null;
  }

  const submit = async (commissions: any, form: any) => {
    let formData = new FormData();
    if (!commissions?.id) {
      formData.append("value", String(form.value));
      formData.append("province", String(form.province));
      formData.append("status", String(form.status));
      formData.append("type", String(form.type));

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          Authorization: myHeaders,
        },
      };

      fetch(`${URL_API}/commissions`, requestOptions)
        .then(() => {
          return CustomToast({
            status: 200,
            msg: "",
            title: "Comision creada con exito",
          });
        })
        .then((result) => console.log(result))
        .catch((error) => console.error(error));
    }

    formData.append("_method", 'PUT');
    formData.append("value", String(form.value));
    formData.append("province", String(form.province));
    formData.append("status", String(form.status));
    formData.append("type", String(form.type));

    const requestOptions = {
      method: "PUT",
      body: formData,
      headers: {
        Authorization: myHeaders, // Un ejemplo de header de autenticación
      },
    };

    fetch(`${URL_API}/commissions/${commissions.id}`, requestOptions)
      .then(() => {
        return CustomToast({
          status: 200,
          msg: "",
          title: "Comision actualizada con exito",
        });
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  const commissions = data.data;

  return (
    <div className="m-auto md:w-[80%] px-4 py-4 bg-white rounded-lg shadow-sm border">
      <div className="grid grid-cols-2 gap-2">
        <div className="py-4">
          <span className="text-primary font-bold text-xl mb-4 block">
            Comisiones
          </span>
          <div>
            <span className="block font-bold"></span>
            <span></span>
          </div>

          <div className="flex justify-between mb-4">
            <div className="w-full">
              <span className="block font-bold">Comision aplicada en %</span>
              <input
                type="number"
                id="form-phone"
                className="border-0 rounded-md w-full"
                defaultValue={`${commissions?.value ?? 0}`}
                onChange={(e) => {
                  setForm({
                    ...form,
                    value: e.target.value,
                  });
                }}
              />
              <span className="block">Agregá un valor hasta el 99%</span>
            </div>
          </div>

          <label className="font-bold cursor-pointer bg-[#8B9456] block w-full text-white rounded-md py-2 text-center">
            Aplicar
            <button
              className="hidden"
              onClick={() => submit(commissions, form)}
            ></button>
          </label>
          <hr />
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Comisiones;
